const salt = 'chloride';
export async function digestPassword(text: string) {
	let buf = (new TextEncoder()).encode(text + salt).buffer;
	for (let i = 0; i < 100; i++) buf = await window.crypto.subtle.digest('SHA-256', buf);
	return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
}

export const getEventValue = (e: Event) => (e.target as HTMLInputElement).value;
